import configJson from "@/config/shared/workflows/workflow_actions.json";

type WorkflowsConfiguration = typeof configJson;

const config: WorkflowsConfiguration = configJson;

export const getWorkflowsConfiguration = (): WorkflowsConfiguration => config;

type ActionType = keyof typeof config.actions;

export const isActionLimitedToTriggers = (actionType: string): boolean =>
  actionType in config.actions &&
  Boolean(config.actions[actionType as ActionType]?.limited_to_triggers);

export const getActionLimitedTriggers = (actionType: string): string[] =>
  actionType in config.actions
    ? config.actions[actionType as ActionType]?.limited_to_triggers || []
    : [];

export const isActionCompatibleWithTrigger = (
  actionType: string,
  triggerType: string | undefined,
): boolean => {
  // If action is not configured, it's compatible with all triggers
  if (!isActionLimitedToTriggers(actionType)) {
    return true;
  }

  // If no trigger is provided, action is not compatible
  if (!triggerType) {
    return false;
  }

  // Check if trigger is in the allowed list
  const allowedTriggers = getActionLimitedTriggers(actionType);
  return allowedTriggers.includes(triggerType);
};

export type { WorkflowsConfiguration };
